// String arithmetic avoids float multiplication: `19.9 * 100` is `1989.9999999999998`, not `1990`.
export function parseFeeBasisPoints(text: string): number | null {
    if (text === '' || text === '.') return null;

    const [wholePart = '', fractionPart = ''] = text.split('.');
    const whole = wholePart === '' ? 0 : Number(wholePart);
    const fraction = fractionPart.padEnd(2, '0').slice(0, 2);

    return whole * 100 + Number(fraction);
}
